export const localizationNavMenu = {
  pageTitle: {
    en: 'Online Banking',
    nb: 'Nettbank',
    nn: 'Nettbank',
  },
  bankAccounts: {
    en: 'Account overview',
    nb: 'Kontooversikt',
    nn: 'Kontooversikt',
  },
  caseManagement: {
    en: 'Case Management',
    nb: 'Saksbehandling',
    nn: 'Saksbehandling',
  },
  documents: {
    en: 'Documents and letters',
    nb: 'Dokumenter og brev',
    nn: 'Dokumenter og brev',
  },
  menuAriaLabel: {
    en: 'Application details menu',
    nb: 'Søknadsdetaljer meny',
    nn: 'Søknadsdetaljar meny',
  },
  applyForChange: {
    en: 'Apply for a change',
    nb: 'Søk om endring',
    nn: 'Søk om endring',
  },
} as const;
